module.exports = __webpack_public_path__ + "assets/img/img52.f5af7a5f.png";